<template>
  <div class="inner">
    <div class="page_con">
      <div class="page_ttl">
        <h1 class="h1">
          <span>원격지원</span>
        </h1>
      </div>
      <div class="page_con">
        <div class="complete">
          <p>
                            <span class="big">
                                여러가지 오류사항에 대한<br>조치가 어려우신 경우,
                                <span class="bold">
                                    전문 담당자가<br>회원님의 컴퓨터를 같이 보면서<br>
                                    장애 원인을 해결해드립니다.
                                </span><br>
                            </span>
            <br>
            <span class="color bold">
                                원격지원 서비스 관련 문의사항은<br>
                                전화주시면 응대해드리겠습니다.<br>
                                T: 02-449-5009
                            </span>
          </p>
        </div>
      </div>
      <div class="page_btn">
        <button class="btn" @click="fnService">원격지원서비스 시작하기</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'info-remote-index',
  methods: {
    fnService: function() {
      alert('원격지원은 pc에서만 가능합니다.')
    }
  }
}
</script>

<style scoped>

</style>
